export default __webpack_public_path__ + "static/media/Strugani 23.ab155f8a.jpg";